import packageJson from '../../package.json';

export const APP_VERSION = packageJson.version;

export const getCommitHash = () => {
  return process.env.REACT_APP_GIT_COMMIT || null;
};

export const getEnvironment = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
  
  if (baseUrl.includes('staging')) {
    return 'STAGING';
  } else if (baseUrl.includes('localhost') || baseUrl.includes('127.0.0.1')) {
    return 'LOCAL';
  }
  
  return null;
};

export const getVersionDisplay = () => {
  const env = getEnvironment();
  const commit = getCommitHash();
  const version = APP_VERSION;
  
  let display = '';
  
  if (env) {
    display += `${env} `;
  }
  
  display += `v${version}`;
  
  if (commit) {
    display += ` (${commit.substring(0, 7)})`;
  }
  
  return display;
};
